import './quick-access.scss';

class QuickAccess {
    constructor (element) {
        this.$quickAccess = element;
        this.$$footers = document.querySelectorAll('footer');
        this.$siteFooter = this.$$footers[this.$$footers.length - 1];
    }

    initialize () {
        this.handleSizeOnScroll();

        if (this.$siteFooter) {
            this.toggleVisibility();
        }
    }

    handleSizeOnScroll () {
        window.eventScroller.customFunctions.push(() => {
            if (window.scrollDirection === 'up') {
                this.$quickAccess.setAttribute('data-quick-access-size', 'big');
            }

            if (window.scrollDirection === 'down') {
                this.$quickAccess.setAttribute('data-quick-access-size', 'small');
            }
        });
    }

    toggleVisibility () {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.$quickAccess.setAttribute('inert', '');
                } else {
                    this.$quickAccess.removeAttribute('inert');
                }

                this.$quickAccess.setAttribute('data-quick-access-inactive', !entry.isIntersecting);
            });
        });

        observer.observe(this.$siteFooter);
    }
}

export { QuickAccess };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-quick-access="root"]');

        $$roots.forEach($root => {
            const $rootAPI = new QuickAccess($root);
            $rootAPI.initialize();
        });
    }
});
